var Backbone = bookedby.deps != null ? bookedby.deps.Backbone : global.Backbone;

var RitualModel = Backbone.Epoxy.Model.extend({
});

module.exports = RitualModel;